<template lang="pug">
    model-form(
        ref='form'
        submit-text='guardar'
        title='Crear prestamo'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submit'
    )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import EmployeeLoanCompanyModel from '@/models/HumanResource/HrEmployeeLoanCompany'
    import EmployeeLoanCompanyFields from '@/views/HumanResource/HrEmployeeLoanCompany/HrEmployeeLoanCompanyFields'
    //
    export default {
        name: 'employee-loan-company-create',
        components: {
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            formProps() {
                return {
                    fields: EmployeeLoanCompanyFields,
                }
            }
        },
        data() {
            return {
                formData: new EmployeeLoanCompanyModel(),
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(EmployeeLoanCompanyModel, error.response.data))
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'employee-loan-company-list' })
            },

            /**
             * 
             */
            submit() {
                return this.$refs.form
                    .setWait(true)
                    .then(this.toCreate)
                    .then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            success() {
                this.setSuccessSnackbar('Prestamo agregado exitosamente.')
            },

            /**
             *
             */
            toCreate(model) {
                return model
                    .toCreate()
                    .save()
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },
        },
        mounted() {
            this.setTitleTopBar('Crear prestamo')
        },
    }
</script>